import { Module } from "wrapper6";
import $ from 'jquery';

export default class TopMenu extends Module {
    ready() {

        let elems = document.getElementsByClassName('scrollto');

        $(window).scroll(function(){

            for (let i = 0;i < elems.length;i++){
                let elem = elems[elems.length-1-i];
                let target = document.getElementById(elem.getAttribute('href').replace('#', ''));

                if(target && target.getBoundingClientRect().top - 500 < 0){
                    if(elem.parentElement.classList.contains('active-st')){
                        return;
                    }
                    $('.active-st').removeClass('active-st');
                    elem.parentElement.classList.add('active-st');
                    return;
                }
            }

        });

    }
}